import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styles from "../../assets/containers/lessonCard.module.css";
import { ArrowRightIcon } from "../../assets/icons/ArrowRight.js";
import { useAppGlobalConfig } from "../../providers/AppGlobalConfigContext";
import { getWizmeId } from "../../helpers/user";
import { getUsageWithFallback } from "../../helpers/progressFallback";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const LessonCard = (props) => {
  const { isEmbedMode } = useAppGlobalConfig();
  const { lesson, groupIndex } = props;
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [tenant, setTenant] = useState();
  const [isComplete, setIsComplete] = useState(false);

  const handleLessonClick = async (lessonId) => {
    setIsLoading(true);

    let blockIndex = 0;
    try {
      const platformId = await getWizmeId();
      if (!platformId) throw new Error("Platform ID not found");
      const usageProgressTrackerData = await getUsageWithFallback(
        platformId,
        lessonId,
        tenant,
      );
      const progress = usageProgressTrackerData.data.progress;
      let biggestIndex = Math.max(...progress);
      blockIndex =
        biggestIndex === usageProgressTrackerData.data.totalSections - 1
          ? biggestIndex
          : biggestIndex + 1;
    } catch (err) {
      if (err.status !== 404) {
        console.log("error getting student metrics: ", err);
        return;
      }
    } finally {
      if (!isEmbedMode) localStorage.removeItem("lessons");
      setIsLoading(false);

      const location = `${isEmbedMode ? "/embeddable" : ""}/catchupId/1/lesson/${lessonId}/${blockIndex}`;
      localStorage.setItem("lessonName", lesson.name);
      history.push(location);
    }
  };

  const checkCompleteness = async () => {
    const platformId = await getWizmeId();
    try {
      const usage = await getUsageWithFallback(platformId, lesson.id, tenant);
      setIsComplete(usage.data.progress.length === usage.data.totalSections);
    } catch (err) {
      console.log("Error getting lesson ", lesson.name, ":", err.message);
      setIsComplete(false);
    }
  };

  useEffect(() => {
    isEmbedMode ? setTenant("cupheadless") : setTenant("cupfranchise");
  }, []);

  useEffect(() => {
    isEmbedMode ? setTenant("cupheadless") : setTenant("cupfranchise");
  }, [isEmbedMode]);

  useEffect(() => {
    if (lesson.id && tenant) {
      checkCompleteness();
    }
  }, [lesson.id, tenant]);

  return (
    <>
      <div key={groupIndex} className={styles["lesson-card"]}>
        {isLoading ? (
          <div className={styles["spinner-container"]}>
            <div className="spinner-border"></div>
          </div>
        ) : (
          <div className={styles["card-content"]}>
            <h2 className={styles["card-title"]}>{lesson.name}</h2>
            <div
              className={styles["card-link"]}
              onClick={() => handleLessonClick(lesson.id)}
            >
              Start Lesson <ArrowRightIcon className={styles["arrow-icon"]} />
            </div>
            <div className={styles["card-completeness"]}>
              {isComplete && (
                <>
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    size={"xs"}
                    className={styles["card-completeness-icon"]}
                  />
                  <span className={styles["card-completeness-text"]}>
                    Completed
                  </span>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default LessonCard;
